/* eslint-disable @typescript-eslint/promise-function-async */
import restClient, { headerKey } from './restClient';
import { apiMap } from '../utilities';

const appointmentService = {
  getProfileToken: (appointmentId: string) => {
    return restClient.makeGetRequest(apiMap.getProfileToken(appointmentId));
  },

  getReceipt: (paymentId: string) => {
    return restClient.makeGetRequest(apiMap.getReceipt(paymentId));
  },

  getAppointments: ({ userID, params }: any) => {
    return restClient.makeGetRequest(apiMap.getAggregateData(userID), params);
  },

  getAppointment: ({ appointmentId }: any) => {
    return restClient.makeGetRequest(apiMap.getAppointment(appointmentId));
  },

  bookAppointment: (params: any) => {
    const config = {
      headers: { [headerKey.AuthToken]: restClient.getHeader(headerKey.AccessToken) },
    };

    if (params.appointmentID)
      return restClient[params.isTeleConsult ? 'makePostRequest' : 'makePutRequest'](apiMap.rescheduleAppointment(params), params, config);

    return restClient.makePostRequest(apiMap.bookAppointment(params), params, config);
  },

  bookZeroFeeTeleConsult: (sessionId: string, params: any) => {
    return restClient.makePostRequest(apiMap.bookZeroFeeTeleConsult(sessionId), params, {
      headers: {
        [headerKey.AuthToken]: restClient.getHeader(headerKey.AccessToken),
      },
    });
  },

  getTeleConsultSession: (sessionId: number) => {
    return restClient.makeGetRequest(apiMap.getTeleConsultSession(sessionId), {
      headers: {
        [headerKey.AuthToken]: restClient.getHeader(headerKey.AccessToken),
      },
    });
  },

  getLatestTeleConsultPayment: (sessionId: number) => {
    return restClient.makeGetRequest(apiMap.getLatestTeleConsultPayment(sessionId), {
      headers: {
        [headerKey.AuthToken]: restClient.getHeader(headerKey.AccessToken),
      },
    });
  },

  initiateTeleConsultPayment: ({ sessionId, amount }: { amount: number, sessionId: number }) => {
    return restClient.makePostRequest(apiMap.initiateTeleConsultPayment(sessionId), { amount }, {
      headers: {
        [headerKey.AuthToken]: restClient.getHeader(headerKey.AccessToken),
      },
    });
  },

  getTeleConsultPricing: ({ doctorID, patientID, appointmentDate }: any) => {
    return restClient.makeGetRequest(apiMap.getTeleConsultPricing(), {
      doctor_id: doctorID,
      patient_id: patientID,
      appointment_date: appointmentDate,
      headers: {
        [headerKey.AuthToken]: restClient.getHeader(headerKey.AccessToken),
      },
    });
  },

  checkCancelEligibility: ({ sessionId }: any) => {
    return restClient.makePostRequest(apiMap.checkCancelEligibility(sessionId), null, {
      headers: {
        [headerKey.AuthToken]: restClient.getHeader(headerKey.AccessToken),
      },
    });
  },

  cancelAppointment: ({ sessionId, ticketID }: any) => {
    return restClient.makePostRequest(apiMap.cancelAppointment(sessionId), {
      ticketID,
      confirmation: 'Accepted',
    }, {
      headers: {
        [headerKey.AuthToken]: restClient.getHeader(headerKey.AccessToken),
      },
    });
  },

  deleteAppointment: (params: { isTeleConsult: boolean; teleConsultSessionID: string; appointmentID: string; }) => {
    return restClient[params.isTeleConsult ? 'makePostRequest' : 'makeDeleteRequest'](apiMap.deleteAppointment(params), null, {
      headers: {
        [headerKey.AuthToken]: restClient.getHeader(headerKey.AccessToken),
      },
    });
  },

  raiseConcernTicket: (email: any, description: any) => {
    return restClient.makePostRequest(apiMap.getHelpAndSupport(), {
      'query': {
        'contact': email,
        'body': description,
      },
    }, {
      headers: {
        [headerKey.AuthToken]: restClient.getHeader(headerKey.AccessToken),
      },
    });
  },
};

export default appointmentService;